/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Box, Card, CardActionArea, CircularProgress, List, ListItem, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import evaluoExamServices from '../../../redux/services/evaluoExamServices';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    minHeight: '250px',
  },
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFF',
    width: '100%',
    maxHeight: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    fontWeight: 'bold',
  },
}));

const EvaluoExamWidget = ({ userData, group }) => {
  const classes = useStyles();
  const [evaluoExams, setEvaluoExams] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await evaluoExamServices.getEvaluoExamsByCompanyAndStudent(
        userData.company._id,
        group.semester,
        userData.evaluoId,
      );
      if (res.message) {
        setLoading(false);
      } else {
        const examsArr = [];
        res.forEach((exam) => {
          if (exam.users && exam.users.length > 0) {
            exam.users.forEach((user) => {
              if (user.user.email === userData.email
                && new Date(exam.temporality.end_at) > new Date()) {
                examsArr.push(exam);
              }
            });
          }
        });
        const sortedArr = examsArr.sort((a, b) => {
          if (a.temporality.start_at < b.temporality.start_at) {
            return -1;
          }
          if (a.temporality.start_at > b.temporality.start_at) {
            return 1;
          }
          return 0;
        });
        setEvaluoExams(sortedArr);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setEvaluoExams([]);
    if (group.semester === userData.semester || userData.catchUp?.includes(group.semester)) {
      getData();
    } else {
      setLoading(false);
    }
  }, [group]);

  const history = useHistory();

  return (
    <Card
      className={classes.root}
      onClick={() => history.push('/evaluo')}
      style={{ cursor: 'pointer' }}
    >
      <CardActionArea
        className={classes.subroot}
      >
        <Typography
          className={classes.cardHeader}
        >
          Evaluo exams
        </Typography>

      </CardActionArea>
      {loading === false
        ? (
          <>
            {evaluoExams.length > 0 ? (
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '10px',
                }}
              >
                <List>
                  {evaluoExams.map((exam) => (
                    <ListItem>
                      <Typography variant="body2">
                        {`Examen de ${moment(new Date(exam.temporality.start_at)).format('HH:mm')} le ${moment(new Date(exam.temporality.start_at)).format('DD/MM/YYYY')} à ${moment(new Date(exam.temporality.end_at)).format('HH:mm')} le ${moment(new Date(exam.temporality.end_at)).format('DD/MM/YYYY')}, durée: ${exam.temporality.duration}`}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            )
              : (
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '85px',
                  }}
                >
                  <Typography variant="body2">
                    Pas d&apos;examen prévu
                  </Typography>
                </Box>
              )}
          </>
        )
        : (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '75px',
            }}
          >
            <CircularProgress />
          </Box>
        )}
    </Card>
  );
};

EvaluoExamWidget.propTypes = {
  userData: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
};

function mapState(state) {
  const { currentGroup } = state.ui;
  const { data } = state.group;
  const { userData } = state.user;
  return {
    userData,
    group: data[currentGroup],
  };
}

export default connect(mapState, {})(EvaluoExamWidget);
